import { View, Text, TouchableOpacity } from "react-native";
import React, { useState } from "react";

import { doc, updateDoc } from "firebase/firestore";
import db from "../Firestore/FirestoreConfig";

import { Entypo } from "@expo/vector-icons";

import Fonts from "../../Resources/Fonts";
import GlobalStyles from "../../Resources/Styles";
import Colors from "../../Resources/Color";
import { observer } from "mobx-react";
import { Menu, MenuItem, MenuDivider } from "react-native-material-menu";
import Block from "../Firestore/Block";
import Workout from "../Firestore/Workout";
import Exercise from "../Firestore/Exercise";
import Serie from "../Firestore/Serie";
import Attribute from "../Firestore/Attribute";
import AddBlockView from "./AddBlockView";

import { Ionicons } from "@expo/vector-icons";
import { FontAwesome5 } from "@expo/vector-icons";
import CopyBlockToClient from "./CopyBlockToClient";

import CustomAlert from "../Components/CustomAlert";
import { useScreenDimensions, useDevice } from "../_layout";

import DeleteBlockView from "./DeleteBlockView";

import { useTranslation } from "react-i18next";
import { useToast } from "../contexts/ToastContext";

const BlockRowView = observer(({ block, labelIdx, idx }) => {
  const { t } = useTranslation();
  const { isMobile } = useDevice();
  const { showToast } = useToast();

  const [showingChangeBlockName, setShowingChangeBlockName] = useState(false);
  const [showingCopyToClient, setShowingCopyToClient] = useState(false);
  // const [showingCopyToLibrary, setShowingCopyToLibrary] = useState(false);
  const [showingDeleteAlert, setShowingDeleteAlert] = useState(false);
  const deleteAlertTitle = "deleteBlockAlertTitle-string";
  const deleteAlertText = "deleteBlockAlertText-string";
  const [blockMenu, setBlockMenu] = useState(false);
  const showBlockMenu = () => setBlockMenu(true);

  const [isHovered, setIsHovered] = useState(false);
  const [isMenuHovered, setIsMenuHovered] = useState(false);
  const [isArrowHovered, setIsArrowHovered] = useState(false);

  const [menuProva, setMenuProva] = useState(false);
  const showMenuProva = () => setMenuProva(true);
  const { screenSize } = useScreenDimensions();

  const onClose = () => {
    setBlockMenu(false);
    setIsHovered(false);
  };

  const showChangeName = () => {
    setShowingChangeBlockName(true);
    setBlockMenu(false);
  };

  const showCopyToClient = () => {
    setShowingCopyToClient(true);
    setBlockMenu(false);
  };

  // const showCopyToLibrary = () => {
  //   setShowingCopyToLibrary(true);
  //   setBlockMenu(false);
  // };

  const addToLibrary = () => {
    setBlockMenu(false);
    block.copyBlockToLibrary(showToast);

    onClose();
  };

  const showDeleteAlert = () => {
    setShowingDeleteAlert(true);
    setBlockMenu(false);
  };

  const deleteBlock = () => {
    block.client.deleteBlock(block);
    setShowingDeleteAlert(false);
  };

  const MenuItemView = ({ index }) => {
    const [isHovered, setIsHovered] = useState(false);

    return index === 0 ? (
      <MenuItem
        onPress={showChangeName}
        style={{ minWidth: 190 }}
        textStyle={{ fontSize: 14, fontWeight: isHovered ? "600" : "normal" }}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {t("edit-string")}
      </MenuItem>
    ) : index === 1 ? (
      <MenuItem
        onPress={makeBlockActive}
        style={{ minWidth: 190 }}
        textStyle={{ fontSize: 14, fontWeight: isHovered ? "600" : "normal" }}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {t("makeActive-string")}
      </MenuItem>
    ) : index === 2 ? (
      <MenuItem
        onPress={() => {
          onClose();
          const newBlock = block.client.copyBlock(
            t,
            block,
            false,
            undefined,
            showToast
          );
          block.client.updateClientTransactionData(newBlock.id);
          block.client.startOrResetBatchTimer();
          setBlockMenu(false);
        }}
        style={{ minWidth: 190 }}
        textStyle={{ fontSize: 14, fontWeight: isHovered ? "600" : "normal" }}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {t("copyBlock-string")}
      </MenuItem>
    ) : index === 3 ? (
      <MenuItem
        onPress={() => {
          onClose();
          const newBlock = block.client.copyBlock(
            t,
            block,
            true,
            undefined,
            showToast
          );
          block.client.updateClientTransactionData(newBlock.id);
          block.client.startOrResetBatchTimer();
          setBlockMenu(false);
        }}
        // onPress={() => {
        //   onClose();
        //   for (let i = 0; i < 50; i++) {
        //     block.copyEntireBlock(setBlockMenu);
        //   }
        // }}
        style={{ minWidth: 190 }}
        textStyle={{ fontSize: 14, fontWeight: isHovered ? "600" : "normal" }}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {t("copyFullBlock-string")}
      </MenuItem>
    ) : index === 4 ? (
      <MenuItem
        onPress={showCopyToClient}
        style={{ minWidth: 190 }}
        textStyle={{ fontSize: 14, fontWeight: isHovered ? "600" : "normal" }}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {t("copyToAnotherClient-string")}
      </MenuItem>
    ) : index === 5 ? (
      <MenuItem
        onPress={addToLibrary}
        style={{ minWidth: 190 }}
        textStyle={{ fontSize: 14, fontWeight: isHovered ? "600" : "normal" }}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {t("exportToLibrary-string")}
      </MenuItem>
    ) : (
      <MenuItem
        onPress={showDeleteAlert}
        style={{ minWidth: 190 }}
        textStyle={{
          fontSize: 14,
          color: "red",
          fontWeight: isHovered ? "600" : "normal",
        }}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {t("delete-string")}
      </MenuItem>
    );
  };

  return (
    <View
      style={{
        flexDirection: "row",
        alignItems: "center",
        marginBottom: 10,
        maxWidth: screenSize != "medium" ? "100%" : "50%",
        marginTop:
          block.label === "" ? (labelIdx !== 0 && idx === 0 ? 20 : 0) : 0,
      }}
    >
      <TouchableOpacity
        onPress={() =>
          !showingChangeBlockName && block.client.setSelectedBlock(block)
        }
        style={[
          GlobalStyles.touchableRow,
          {
            // flex: 1,
            borderWidth: block.isActive ? 1 : 0.1,
            borderColor: block.isActive
              ? Colors.blackColor
              : isHovered
              ? "rgba(0, 0, 0, 0.5)"
              : "rgba(0, 0, 0, 0.1)",
            width: screenSize != "large" ? "auto" : "80%",
            marginBottom: 0,
            flex: 1,
          },
        ]}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <View style={{ alignItems: "flex-start", flex: 1 }}>
          <Text
            numberOfLines={2}
            style={[Fonts.medium14, { marginBottom: 8, fontWeight: "500" }]}
          >
            {block.name}
          </Text>
          <View style={[GlobalStyles.HStack, { maxWidth: "110%" }]}>
            {/* <FontAwesome5
            name="clipboard-list"
            size={13}
            color={Colors.bubbleColor}
            style={{ paddingRight: 5 }}
          /> */}
            {block.isActive && (
              <Text
                style={{
                  marginRight: 10,
                  fontSize: 12,
                  color: Colors.grayColor,
                }}
              >
                {t("active-string")}
              </Text>
            )}
            <Ionicons
              name="calendar"
              size={12}
              color={Colors.bubbleColor}
              style={GlobalStyles.rowIcon}
            />
            <Text
              style={{ ...GlobalStyles.rowSubText, marginRight: 0 }}
              numberOfLines={1}
            >
              {t("clientWeekStatus-string", {
                blockCurrentWeek: block.getWeeks,
                blockWeeks: block.totalWeeks,
              })}
            </Text>
          </View>
        </View>

        <Menu
          visible={blockMenu}
          anchor={
            <TouchableOpacity
              onPress={showBlockMenu}
              onMouseEnter={() => !isMobile && setIsMenuHovered(true)}
              onMouseLeave={() => setIsMenuHovered(false)}
            >
              <Entypo
                name="dots-three-horizontal"
                size={22}
                color="black"
                style={{
                  opacity: isMenuHovered ? 0.5 : 1,
                  ...GlobalStyles.rowThreeDots,
                }}
              />
            </TouchableOpacity>
          }
          style={GlobalStyles.menu}
          onRequestClose={() => {
            setBlockMenu(false);
            setIsHovered(false);
          }}
        >
          <MenuItemView index={2} />
          <MenuItemView index={3} />
          <MenuItemView index={4} />
          <MenuItemView index={5} />
          <MenuItemView index={6} />
        </Menu>
      </TouchableOpacity>
      <TouchableOpacity
        onPress={() => block.client.setShownBlock(block)}
        onMouseEnter={() => !isMobile && setIsArrowHovered(true)}
        onMouseLeave={() => setIsArrowHovered(false)}
      >
        <Ionicons
          name={
            block.isShown
              ? "arrow-forward-circle"
              : "arrow-forward-circle-outline"
          }
          size={24}
          color="black"
          style={{
            paddingVertical: 10,
            marginLeft: screenSize === "small" ? 8 : 16,
            marginRight: screenSize === "large" ? 16 : 0,
            opacity: isArrowHovered ? 0.5 : 1,
          }}
        />
      </TouchableOpacity>
      {showingChangeBlockName && (
        <AddBlockView
          isVisible={showingChangeBlockName}
          onClose={() => setShowingChangeBlockName(false)}
          block={block}
          client={block.client}
        />
      )}
      {showingCopyToClient && (
        <CopyBlockToClient
          isVisible={showingCopyToClient}
          onClose={() => setShowingCopyToClient(false)}
          block={block}
        />
      )}

      {showingDeleteAlert && (
        <DeleteBlockView
          isVisible={showingDeleteAlert}
          onClose={() => setShowingDeleteAlert(false)}
          title={deleteAlertTitle}
          text={deleteAlertText}
          action={deleteBlock}
          nameOfBlock={block ? block.name : ""}
        />
      )}
    </View>
  );
});
export default BlockRowView;
